import Flex from 'components/ui/Flex';
import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Col } from 'reactstrap';
import styled from 'styled-components';
import ProductImages from './ProductImages';

const ProductDetailPageImage = ({ loading = false }: { loading: boolean }) => {
    const [currentSlideImageIndex, setCurrentSlideImageIndex] = useState<number>(0); // TODO: Figure out why this is needed...

    return (
        <Col xs="12" md="5" xl="6" className="p-0 p-md-auto pe-0 position-relative">
            <ImageButtonWrapper justify="between" className="w-100 pt-3 px-4">
                <Flex></Flex>
            </ImageButtonWrapper>
            <ImageContainer className="">
                {loading ? (
                    <>
                        <Skeleton height={'70vh'}></Skeleton>
                        <Skeleton height={50}></Skeleton>
                    </>
                ) : (
                    <ProductImages onImageChange={(currentIndex: number) => setCurrentSlideImageIndex(currentIndex)} />
                )}
            </ImageContainer>
        </Col>
    );
};

export default ProductDetailPageImage;

const ImageButtonWrapper = styled(Flex)`
    position: absolute;
    top: 0;
    left: 0;
    font-size: 14px;
    z-index: 2;
`;

const ImageContainer = styled.div``;
